const FETCH_USER_ADDRESS = "user/address/FETCH_USER_ADDRESS";
const FETCH_USER_ADDRESS_SUCCESS = "user/address/FETCH_USER_ADDRESS_SUCCESS";
const FETCH_USER_ADDRESS_FAIL = "user/address/FETCH_USER_ADDRESS_FAIL";
const UPDATE_USER_ADDRESS = "user/address/UPDATE_USER_ADDRESS";
const UPDATE_USER_ADDRESS_SUCCESS = "user/address/UPDATE_USER_ADDRESS_SUCCESS";
const UPDATE_USER_ADDRESS_FAIL = "user/address/UPDATE_USER_ADDRESS_FAIL";
const SUBMIT_USER_ADDRESS = "user/address/SUBMIT_USER_ADDRESS";
const SUBMIT_USER_ADDRESS_SUCCESS = "user/address/SUBMIT_USER_ADDRESS_SUCCESS";
const SUBMIT_USER_ADDRESS_FAIL = "user/address/SUBMIT_USER_ADDRESS_FAIL";
const initialState = {
  pending: true,
  loaded: false,
  oldAddress: {},
  address: {},
  errors: null,
  dirty: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_USER_ADDRESS:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case FETCH_USER_ADDRESS_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        dirty: false,
        oldAddress: { ...action.results },
        address: { ...action.results },
        errors: null
      });
    case FETCH_USER_ADDRESS_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        errors: action.errors
      });
    case UPDATE_USER_ADDRESS:
      return Object.assign({}, state, {
        dirty: true,
        address: action.address
      });
    case UPDATE_USER_ADDRESS_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        address: { ...action.results },
        errors: null
      });
    case UPDATE_USER_ADDRESS_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        errors: action.errors
      });
    case SUBMIT_USER_ADDRESS:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case SUBMIT_USER_ADDRESS_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        oldAddress: { ...action.results },
        address: { ...action.results },
        dirty: false,
        errors: null
      });
    case SUBMIT_USER_ADDRESS_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        errors: action.errors
      });
    default:
      return state;
  }
}

export function fetchUserAddressPending() {
  return {
    type: FETCH_USER_ADDRESS
  };
}

export function fetchUserAddressSuccess(results) {
  return {
    type: FETCH_USER_ADDRESS_SUCCESS,
    results
  };
}

export function fetchUserAddressFail(errors) {
  return {
    type: FETCH_USER_ADDRESS_FAIL,
    errors
  };
}

export function updateUserAddress(address) {
  return {
    type: UPDATE_USER_ADDRESS,
    address
  };
}

export function updateUserAddressSuccess(results) {
  return {
    type: UPDATE_USER_ADDRESS_SUCCESS,
    results
  };
}

export function updateUserAddressFail(errors) {
  return {
    type: UPDATE_USER_ADDRESS_FAIL,
    errors
  };
}

export function submitUserAddressPending() {
  return {
    type: SUBMIT_USER_ADDRESS
  };
}

export function submitUserAddressSuccess(results) {
  return {
    type: SUBMIT_USER_ADDRESS_SUCCESS,
    results
  };
}

export function submitUserAddressFail(errors) {
  return {
    type: SUBMIT_USER_ADDRESS_FAIL,
    errors
  };
}

export const getAddress = state => state.address;
export const getValidAddress = state => state.oldAddress;
export const getAddressError = state => state.errors;
export const getAddressPending = state => state.pending;
export const getAddressLoaded = state => state.loaded;
export const getAddressDirty = state => state.dirty;
